require('/ui/utilities/a11y.module.scss.module.css');

export const srOnly = "_sr-only_12rvz_1";
